import { BillsSearchParameters } from '../models/api/view/claim/financials/bills/bills-search-parameters';

/**
 * Utility for building and validating bill search parameters
 */
export class BillSearchParamsBuilder {
  /**
   * Build search parameters from form values
   * Validates and sanitizes input values
   */
  static build(formValues: {
    payee: string | null;
    vendor: string | null;
    treating: string | null;
    billStatus: string | null;
    icn: string | null;
    transactionDateStart: Date | null;
    transactionDateEnd: Date | null;
  }): BillsSearchParameters | null {
    const searchParams: BillsSearchParameters = {};

    // Set dropdown parameters (default to 'ALL' if empty)
    searchParams.Payee = formValues.payee || 'ALL';
    searchParams.Vendor = formValues.vendor || 'ALL';
    searchParams.Provider = formValues.treating || 'ALL';
    searchParams.Status = formValues.billStatus || 'ALL';

    // Add optional ICN parameter only if it has a value and is valid
    if (formValues.icn && formValues.icn.trim() !== '') {
      // Validate ICN format
      const sanitizedIcn = formValues.icn.trim();
      if (!this.isValidIcn(sanitizedIcn)) {
        // Invalid ICN format
        return null;
      }
      searchParams.Icn = sanitizedIcn;
    }

    // Add optional date parameters only if they have values
    if (formValues.transactionDateStart) {
      searchParams.BillDateFrom = formValues.transactionDateStart;
    }
    if (formValues.transactionDateEnd) {
      searchParams.BillDateTo = formValues.transactionDateEnd;
    }

    return searchParams;
  }

  /**
   * Validate ICN format
   * Ensures ICN doesn't contain suspicious characters
   */
  private static isValidIcn(icn: string): boolean {
    // Must be 50 characters or less and contain only alphanumeric characters and hyphens
    return icn.length <= 50 && /^[a-zA-Z0-9-]+$/.test(icn);
  }
}
